import { render, staticRenderFns } from "./IndividualMatchEntryQuestions.vue?vue&type=template&id=8debd176&scoped=true&lang=pug&"
import script from "./IndividualMatchEntryQuestions.vue?vue&type=script&lang=js&"
export * from "./IndividualMatchEntryQuestions.vue?vue&type=script&lang=js&"
import style0 from "./IndividualMatchEntryQuestions.vue?vue&type=style&index=0&id=8debd176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8debd176",
  null
  
)

export default component.exports